'use strict';

namespace Search {

    export enum UnifiedSearchType {
        Holidays = 1,
        Hotels,
        Flights,
        Transfers,
        Cruises,
        Marhaba,
        HolidayDeals,
        Insurance
    }

    export class UnifiedSearchModel {
        occupancy: SearchOccupancy[];
        currency: string;
        startDate: string;
        endDate: string;
        noDatesYet: boolean;
        cabin: number;
        airports: any[];
        destination: any[];
        onewayonly: boolean;
        flexibleDates: boolean;
        airlines: Airline[];
        prefilterDirectFlights: boolean;
        month: number;
        duration: number;
        domainId: number;
    }

}
